module.exports = __webpack_public_path__ + "img/logo.e1588a1c.png";